<template>
  <div class="animated fadeIn">
    <b-card-group class="mb-4">
      <b-card
        header-tag="header"
        footer-tag="footer"
        class="col-md-8 p-0 mr-2">
        <div slot="header">
          <strong> Filtros </strong>
          <b-button variant="primary" class="text-white float-right" size="xs" @click="filtrosAvancados()">Avançado</b-button>
        </div>
        <div class="p-1 mt-2">
          <b-row class="mb-1">
            <b-col sm="12" md="5" class="d-md-block">
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" buttons button-variant="outline-primary" v-model="filtro.fields.periodo" @change="changePeriodo" name="radiosBtn">
                  <b-form-radio class="mx-0" value="Hoje">Hoje</b-form-radio>
                  <b-form-radio class="mx-0" value="Ontem">Ontem</b-form-radio>
                  <b-form-radio class="mx-0" value="Semana">Semana</b-form-radio>
                  <b-form-radio class="mx-0" value="Mes">Mês</b-form-radio>
                  <b-form-radio class="mx-0" value="Periodo">Período</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="4" class="pr-md-0 mb-1 mb-md-0">
              <multiselect v-model="filtro.fields.gestao" :options="filtro.listas.gestao" placeholder="Todas as Gestões" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
                <template slot="clear">
                  <div class="multiselect__clear" v-if="filtro.fields.gestao.length" @mousedown.prevent.stop="clearAll('gestao')"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col sm="4" class="pr-md-0 mb-1 mb-md-0">
              <multiselect v-model="filtro.fields.centres" :options="filtro.listas.centresFiltradosPorGestao" placeholder="Todas as Lojas" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
                <template slot="clear">
                  <div class="multiselect__clear" v-if="filtro.fields.centres.length" @mousedown.prevent.stop="clearAll('centres')"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col sm="4">
              <multiselect v-model="filtro.fields.formaVenda" :options="filtro.listas.formaVenda" placeholder="Todas as Formas de Venda" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
                <template slot="clear">
                  <div class="multiselect__clear" v-if="filtro.fields.formaVenda.length" @mousedown.prevent.stop="clearAll('formaVenda')"></div>
                </template>
              </multiselect>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="6" sm="6" md="4" class="pr-md-0 pr-1">
              <b-form-input :plain="true" v-model="filtro.fields.dataIni" type="date" @change="dataChanged"></b-form-input>
            </b-col>
            <b-col cols="6" sm="6" md="4" class="pr-md-0 pl-1 pl-md-3">
              <b-form-input :plain="true" v-model="filtro.fields.dataFim" type="date" @change="dataChanged"></b-form-input>
            </b-col>
            <b-col sm="1" v-if="!filtro.filtrosAvancados">
              <b-button variant="primary" class="my-2 my-sm-0 text-white" :class="{'btn-block': $mq === 'sm'}" @click="search()">
                <i class="fa fa-search"></i>
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mb-1" v-if="filtro.filtrosAvancados">
            <b-col cols="6" sm="6" md="4" class="pr-md-0 pl-1 pl-md-3">
              <multiselect v-model="filtro.fields.fornecedores" :options="filtro.listas.fornecedores" placeholder="Todos os Fornecedores" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
                <template slot="clear">
                  <div class="multiselect__clear" v-if="filtro.fields.fornecedores.length" @mousedown.prevent.stop="clearAll('fornecedores')"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col cols="6" sm="6" md="4" class="pr-md-0 pr-1 mb-1">
              <multiselect v-model="filtro.fields.grupos" :options="filtro.listas.grupos" placeholder="Todos os Grupos" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
                <template slot="clear">
                  <div class="multiselect__clear" v-if="filtro.fields.grupos.length" @mousedown.prevent.stop="clearAll('grupos')"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col cols="6" sm="6" md="4" class="mb-1">
              <multiselect v-model="filtro.fields.subgrupos" :options="filtro.listas.subgrupos" placeholder="Todos os Subgrupos" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
                <template slot="clear">
                  <div class="multiselect__clear" v-if="filtro.fields.subgrupos.length" @mousedown.prevent.stop="clearAll('subgrupos')"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col cols="6" sm="6" md="4" class="pr-md-0 pl-1 pl-md-3" v-if="classe1">
              <multiselect v-model="filtro.fields.classificacoes1" :options="classificacoes1" :placeholder="'Todos ('+classe1.text+')'" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
              </multiselect>
            </b-col>
            <b-col cols="6" sm="6" md="4" class="pr-md-0 pl-1 pl-md-3" v-if="classe2">
              <multiselect v-model="filtro.fields.classificacoes2" :options="classificacoes2" :placeholder="'Todos ('+classe2.text+')'" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
              </multiselect>
            </b-col>
            <b-col cols="6" sm="6" md="4" class="pr-md-0 pl-1 pl-md-3" v-if="classe3">
              <multiselect v-model="filtro.fields.classificacoes3" :options="classificacoes3" :placeholder="'Todos ('+classe3.text+')'" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
              </multiselect>
            </b-col>
            <b-col cols="6" sm="6" md="4" class="pr-md-0 pl-1 pl-md-3">
              <multiselect v-model="filtro.fields.vendedores" :options="filtro.listas.vendedores" placeholder="Todos os Vendedores" :multiple="true" :close-on-select="false" :clear-on-select="true" :show-labels="false" label="text" track-by="value">
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span v-if="values.length == 1 && !isOpen">{{ values.length }} opção selecionada</span>
                  <span v-if="values.length >= 2 && !isOpen">{{ values.length }} opções selecionadas</span>
                </template>
                <template slot="clear">
                  <div class="multiselect__clear" v-if="filtro.fields.vendedores.length" @mousedown.prevent.stop="clearAll('vendedores')"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col sm="12" md="12" class="mt-2 mb-2">
              <div class="custom-control custom-checkbox pt-1">
                <input type="checkbox" class="custom-control-input" id="chkDesconsiderarPecas" v-model="filtro.fields.desconsiderarPecas">
                <label class="custom-control-label" for="chkDesconsiderarPecas">Desconsiderar devoluções em "Peças"</label>
              </div>
            </b-col>
            <b-col sm="12" md="10" lg="11" class="mt-2 mb-2">
              <div class="custom-control custom-checkbox pt-1">
                <input type="checkbox" class="custom-control-input" id="chkAtendimentoPorCliente" v-model="filtro.fields.atendimentoPorCliente">
                <label class="custom-control-label" for="chkAtendimentoPorCliente">Considerar atendimento único as vendas para o mesmo cliente</label>
              </div>
            </b-col>
            <b-col sm="1" md="1">
              <b-button variant="primary" class="my-2 my-sm-0 text-white" :class="{'btn-block': $mq === 'sm'}" @click="search()">
                <i class="fa fa-search"></i>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <b-card
        header-tag="header"
        footer-tag="footer"
        class="col-md-4 p-0">
        <div slot="header">
          <strong> Layout </strong>
        </div>
        <div class="p-1">
          <b-row class="mb-1">
            <b-col sm="12" class="d-md-block">
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" buttons button-variant="outline-primary" v-model="filtro.fields.exibicao" name="radiosBtn">
                  <b-form-radio class="mx-0" value="Graficos" @click="loaded = true">Gráficos</b-form-radio>
                  <b-form-radio class="mx-0" value="Tabelas">Tabelas</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="12">
              <b-form-select :plain="true" v-model="filtro.fields.agrupamento" :options="filtro.listas.agrupamentos" :disabled="filtro.fields.centres.length !== 0" @change="search"></b-form-select>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-card-group>

    <div v-if="filtro.fields.exibicao === 'Tabelas'">
      <b-row v-for="(item, index) in items" :key="index">
        <b-col cols="12" sm="12" lg="12">
          <c-table :table-data="item.records" :fields="fields" striped small :caption="item.name" :per-page="50"></c-table>
        </b-col>
      </b-row>
    </div>

    <div v-if="filtro.fields.exibicao === 'Graficos'">
      <b-card v-for="(item, index) in items" :key="index">
        <div slot="header" class="font-weight-bold">{{ item.name }}</div>

        <b-card-group columns class="card-columns mb-4">
          <b-card class="mr-md-2">
            <div slot="header" class="text-black">
              <div class="d-flex">
                <div class="d-flex-inline mr-auto">
                  <strong>Vendas</strong>
                </div>
                <div class="d-flex-inline ml-auto">
                  <i class="fa fa-download text-primary cursor-pointer" @click="export2image('chart-pie-01', `${item.name} - Vendas`)" title="Exportar"></i>
                </div>
              </div>
            </div>
            <pie :chartdata="item.charts.Vendas" :height="(item.charts.Vendas.datasets[0].data.length + 10) * 15" :moneyFormat="true" chartId="chart-pie-01" v-if="loaded && displayChart(item, 'Vendas')" />
            <div class="alert alert-secondary text-center mb-0" v-if="!displayChart(item, 'Vendas')">
              Nenhum resultado encontrado.
            </div>
          </b-card>
          <b-card class="mr-md-2">
            <div slot="header" class="text-black">
              <div class="d-flex">
                <div class="d-flex-inline mr-auto">
                  <strong>Peças</strong>
                </div>
                <div class="d-flex-inline ml-auto">
                  <i class="fa fa-download text-primary cursor-pointer" @click="export2image('chart-pie-02', `${item.name} - Peças`)" title="Exportar"></i>
                </div>
              </div>
            </div>
            <pie :chartdata="item.charts.Pecas" :height="(item.charts.Pecas.datasets[0].data.length + 10) * 15" chartId="chart-pie-02" v-if="loaded && displayChart(item, 'Pecas')" />
            <div class="alert alert-secondary text-center mb-0" v-if="!displayChart(item, 'Pecas')">
              Nenhum resultado encontrado.
            </div>
          </b-card>
          <b-card>
            <div slot="header" class="text-black">
              <div class="d-flex">
                <div class="d-flex-inline mr-auto">
                  <strong>Atendimentos</strong>
                </div>
                <div class="d-flex-inline ml-auto">
                  <i class="fa fa-download text-primary cursor-pointer" @click="export2image('chart-pie-03', `${item.name} - Atendimentos`)" title="Exportar"></i>
                </div>
              </div>
            </div>
            <pie :chartdata="item.charts.Atendimentos" :height="(item.charts.Atendimentos.datasets[0].data.length + 10) * 15" chartId="chart-pie-03" v-if="loaded && displayChart(item, 'Atendimentos')" />
            <div class="alert alert-secondary text-center mb-0" v-if="!displayChart(item, 'Atendimentos')">
              Nenhum resultado encontrado.
            </div>
          </b-card>
        </b-card-group>

        <b-card-group columns class="card-columns">
          <b-card class="mr-md-2">
            <div slot="header" class="text-black">
              <div class="d-flex">
                <div class="d-flex-inline mr-auto">
                  <strong>V/P</strong>
                </div>
                <div class="d-flex-inline ml-auto">
                  <i class="fa fa-download text-primary cursor-pointer" @click="export2image('chart-bar-01', `${item.name} - VP`)" title="Exportar"></i>
                </div>
              </div>
            </div>
            <horizontal-bar :chartdata="item.charts.VP" :height="(item.charts.VP.datasets[0].data.length + 10) * 10" :displayLegend="false" :moneyFormat="true" chartId="chart-bar-01" v-if="loaded && displayChart(item, 'VP')" />
            <div class="alert alert-secondary text-center mb-0" v-if="!displayChart(item, 'VP')">
              Nenhum resultado encontrado.
            </div>
          </b-card>
          <b-card class="mr-md-2">
            <div slot="header" class="text-black">
              <div class="d-flex">
                <div class="d-flex-inline mr-auto">
                  <strong>V/A</strong>
                </div>
                <div class="d-flex-inline ml-auto">
                  <i class="fa fa-download text-primary cursor-pointer" @click="export2image('chart-bar-02', `${item.name} - VA`)" title="Exportar"></i>
                </div>
              </div>
            </div>
            <horizontal-bar :chartdata="item.charts.VA" :height="(item.charts.VA.datasets[0].data.length + 10) * 10" :displayLegend="false" :moneyFormat="true" chartId="chart-bar-02" v-if="loaded && displayChart(item, 'VA')" />
            <div class="alert alert-secondary text-center mb-0" v-if="!displayChart(item, 'VA')">
              Nenhum resultado encontrado.
            </div>
          </b-card>
          <b-card>
            <div slot="header" class="text-black">
              <div class="d-flex">
                <div class="d-flex-inline mr-auto">
                  <strong>P/A</strong>
                </div>
                <div class="d-flex-inline ml-auto">
                  <i class="fa fa-download text-primary cursor-pointer" @click="export2image('chart-bar-03', `${item.name} - PA`)" title="Exportar"></i>
                </div>
              </div>
            </div>
            <horizontal-bar :chartdata="item.charts.PA" :height="(item.charts.PA.datasets[0].data.length + 10) * 10" :displayLegend="false" chartId="chart-bar-03" v-if="loaded && displayChart(item, 'PA')" />
            <div class="alert alert-secondary text-center mb-0" v-if="!displayChart(item, 'PA')">
              Nenhum resultado encontrado.
            </div>
          </b-card>
        </b-card-group>
      </b-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import API from '@/core/api';
import cTable from '@/core/components/Table.vue'
import Multiselect from 'vue-multiselect'
import HorizontalBar from '@/core/components/charts/HorizontalBar';
import Pie from '@/core/components/charts/Pie';
import session from '@/shared/session';
import lojasPorGestaoMultiMixin from '@/core/mixins/lojasPorGestaoMulti.mixin.js';

export default {
  name: 'Vendas',
  components: {
    cTable,
    Multiselect,
    HorizontalBar,
    Pie
  },
  mixins:[
    lojasPorGestaoMultiMixin
  ],
  data: () => {
    return {
      loaded: false,
      filtro: {
        listas: {
          gestao: session.get('gestoes').filter(c => c.value !== 0),
          centres: session.get('lojas').filter(c => c.value !== 0),
          centresDefault: session.get('lojas'),
          formaVenda: session.get('formas').filter(c => c.value !== 0),
          classes: session.get('classes'),
          classificacoes: session.get('classificacoes'),
          grupos: session.get('grupos'),
          subgrupos: session.get('subgrupos'),
          fornecedores: session.get('fornecedores'),
          vendedores: session.get('vendedores'),
          agrupamentos: [{value: 1, text: 'Gestão/Loja'}, {value: 2, text: 'Gestão/Vendedor'}, {value: 3, text: 'Grupo Empresarial/Loja'}, {value: 4, text: 'Grupo Empresarial/Vendedor'}, {value: 5, text: 'Grupo Empresarial/Gestão'}],
          centresFiltradosPorGestao: []
        },
        fields: {
          periodo: 'Hoje',
          gestao: [],
          centres: [],
          formaVenda: [],
          classificacoes1: [],
          classificacoes2: [],
          classificacoes3: [],
          grupos: [],
          subgrupos: [],
          fornecedores: [],
          vendedores: [],
          dataIni: moment().format('YYYY-MM-DD'),
          dataFim: moment().format('YYYY-MM-DD'),
          exibicao: 'Graficos',
          agrupamento: 1,
          desconsiderarPecas: false,
          atendimentoPorCliente: false,
          lojasFuncionario: session.get('lojas').filter(c => c.value !== 0).map( loja => loja.value),
        },
        filtrosAvancados: false
      },
      items: [],
      fields: [
        {key: 'descricao', label: 'Descrição', sortable: true},
        {key: 'meta', label: 'Meta', class: 'text-center'},
        {key: 'vendas', label: 'Vendas R$', sortable: true, currency: true, thClass: 'text-right', tdClass: 'text-right'},
        {key: 'pecas', label: 'Peças', sortable: true, number: true, thClass: 'text-right', tdClass: 'text-right'},
        {key: 'atendimentos', label: 'Atend.', sortable: true, number: true, thClass: 'text-right', tdClass: 'text-right'},
        {key: 'vp', label: 'V/P R$', sortable: true, currency: true, thClass: 'text-right', tdClass: 'text-right'},
        {key: 'va', label: 'V/A R$', sortable: true, currency: true, thClass: 'text-right', tdClass: 'text-right'},
        {key: 'pa', label: 'P/A', sortable: true, numeric: true, thClass: 'text-right', tdClass: 'text-right'},
        {key: 'clientes', label: 'Clientes', sortable: true, number: true, thClass: 'text-right', tdClass: 'text-right'},
        {key: 'taxa_conversao', label: 'Tx. Conv. %', sortable: true, numeric: true, thClass: 'text-right', tdClass: 'text-right'},
        {key: 'descontos', label: 'Descontos R$', sortable: true, currency: true, thClass: 'text-right', tdClass: 'text-right'}
      ],
      charts: {}
    }
  },
  computed: {
    classe1: function() {
      return (this.filtro.listas.classes && this.filtro.listas.classes[0]) || null;
    },
    classe2: function() {
      return (this.filtro.listas.classes && this.filtro.listas.classes[1]) || null;
    },
    classe3: function() {
      return (this.filtro.listas.classes && this.filtro.listas.classes[2]) || null;
    },
    classificacoes1: function() {
      let classificacoes = [];

      if (this.classe1) {
        classificacoes = [ ...this.filtro.listas.classificacoes ].filter(c => c.classe === this.classe1.value);
      }

      return classificacoes;
    },
    classificacoes2: function() {
      let classificacoes = [];

      if (this.classe2) {
        classificacoes = [ ...this.filtro.listas.classificacoes ].filter(c => c.classe === this.classe2.value);
      }

      return classificacoes;
    },
    classificacoes3: function() {
      let classificacoes = [];

      if (this.classe3) {
        classificacoes = [ ...this.filtro.listas.classificacoes ].filter(c => c.classe === this.classe3.value);
      }

      return classificacoes;
    }
  },
  methods: {
    async search() {
      try {
        if (this.validaPeriodo() === true) {
          this.loaded = false

          const metasAPI = new API('api/metas-por-loja');
          const metas = await metasAPI.get({ ...this.parseFilters(this.filtro.fields) });
          this.metas = metas.data;

          const vendasAPI = new API('api/vendas');
          const {data} = await vendasAPI.get({ ...this.parseFilters(this.filtro.fields) });
          this.definirMeta(data);
          this.items = data;

          const { centres, agrupamento } = this.filtro.fields
          if (centres === 0 || agrupamento === 2) {
            this.aplicarAgrupamento();
          }
          this.loadCharts();
        }
      } catch (e) {
        console.error(e)
      }
    },
    aplicarAgrupamento() {
      const { agrupamento } = this.filtro.fields

      if ([1, 2].includes(agrupamento)) {
        let group = []
        let gestoes = this.filtro.listas.gestao.filter(g => g.value && g.value !== 0)
        let _group = _.groupBy(this.items[0].records, 'gestao')
        gestoes.forEach(g => {
          if (_group[g.value]) {
            group.push({
              name: _group[g.value][0].gestao_desc,
              records: [ ..._group[g.value] ],
              grafico: this.items[0].grafico.filter(graf => Number(graf.gestao) === g.value)
            })
          }
        })

        if (group.length > 0) {
          this.items = group
        }
      } else if ([3].includes(agrupamento)) {
        this.items[0].name = 'Grupo Empresarial'
      } else if ([4].includes(agrupamento)) {
        this.items[0].name = 'Grupo Empresarial'
        const outros = this.items[0].grafico.filter(g => g.descricao === 'OUTROS').reduce((acc, cur) => {
          return {
            descricao: 'OUTROS',
            atendimentos: Number(acc.atendimentos || 0) + Number(cur.atendimentos),
            pecas: Number(acc.pecas || 0) + Number(cur.pecas),
            vendas: parseFloat(acc.vendas || 0.00) + parseFloat(cur.vendas),
          }
        }, {})
        this.items[0].grafico = this.items[0].grafico.filter(g => g.descricao !== 'OUTROS')
        this.items[0].grafico.push(outros)
      } else if ([5].includes(agrupamento)) {
        let grouped = []
        let groupBy = Object.values(_.groupBy(this.items[0].records, 'gestao'))
        groupBy.forEach(gestao => {
          const obj = gestao.reduce((acc, cur) => {
            return {
              atendimentos: Number(acc.atendimentos || 0) + Number(cur.atendimentos),
              clientes: Number(acc.clientes || 0) + Number(cur.clientes),
              cod: cur.gestao,
              descontos: parseFloat(acc.descontos || 0.00) + parseFloat(cur.descontos),
              descricao: cur.gestao_desc,
              gestao: cur.gestao,
              gestao_desc: cur.gestao_desc,
              grupo: cur.grupo,
              meta: cur.meta,
              pa: parseFloat(acc.pa || 0.00) + parseFloat(cur.pa),
              pecas: Number(acc.pecas || 0) + Number(cur.pecas),
              taxa_conversao: cur.taxa_conversao,
              va: parseFloat(acc.va || 0.00) + parseFloat(cur.va),
              vendas: parseFloat(acc.vendas || 0.00) + parseFloat(cur.vendas),
              vp: parseFloat(acc.vp || 0.00) + parseFloat(cur.vp),
            }
          }, {})

          grouped.push(obj)
        })

        if (grouped.length > 0) {
          this.items[0] = {
            name: 'Grupo Empresarial',
            records: grouped,
            grafico: grouped
          }
        }
      }
    },
    validaPeriodo() {
      const { dataIni, dataFim } = this.filtro.fields;
      let invalid = false;

      if (
        dataIni === '' ||
        dataFim === '' ||
        moment(dataIni).isAfter(moment(dataFim)) ||
        !moment(dataIni).isValid() ||
        !moment(dataFim).isValid()
      ) {
        invalid = true;
      }

      if (invalid) {
        return swal({
          text: 'Data inválida.'
        });
      }
      return true
    },
    loadCharts() {
      this.items.forEach(items => {
        const labels = items.grafico.map(r => r.descricao).join().split(',');

        items.charts = {
          VP: {
            labels: labels,
            datasets: [
              {
                label: 'V/P',
                backgroundColor: this.dynamicColors(labels.length),
                data: items.records.map(r => r.vp).join().split(',')
              }
            ]
          },
          VA: {
            labels: labels,
            datasets: [
              {
                label: 'V/A',
                backgroundColor: this.dynamicColors(labels.length),
                data: items.records.map(r => r.va).join().split(',')
              }
            ]
          },
          PA: {
            labels: labels,
            datasets: [
              {
                label: 'PA',
                backgroundColor: this.dynamicColors(labels.length),
                data: items.records.map(r => r.pa).join().split(',')
              }
            ]
          },
          Vendas: {
            labels: labels,
            datasets: [
              {
                backgroundColor: this.dynamicColors(labels.length),
                data: items.grafico.map(r => r.vendas).join().split(',')
              }
            ]
          },
          Pecas: {
            labels: labels,
            datasets: [
              {
                backgroundColor: this.dynamicColors(labels.length),
                data: items.grafico.map(r => r.pecas).join().split(',')
              }
            ]
          },
          Atendimentos: {
            labels: labels,
            datasets: [
              {
                backgroundColor: this.dynamicColors(labels.length),
                data: items.grafico.map(r => r.atendimentos).join().split(',')
              }
            ]
          }
        }
      })

      this.loaded = true
    },
    definirMeta(data) {
      data.map(loja => {
        return loja.records.map(e => {
          const porLojaOuVendedor = this.filtro.fields.centres !== 0 ? 'vendedor' : 'loja';
          const loja = this.metas.find(m => m[porLojaOuVendedor] === e.cod)
          if (!loja) {
            e.meta = null;
          } else {
            e.meta = Number(e.vendas) < Number(loja.meta_a/loja.qtd_funcionarios) ? 0
              : Number(e.vendas) >= Number(loja.meta_a/loja.qtd_funcionarios) && Number(e.vendas) < Number(loja.meta_b/loja.qtd_funcionarios) ? 1
                : Number(e.vendas) >= Number(loja.meta_b/loja.qtd_funcionarios) && Number(e.vendas) < Number(loja.meta_c/loja.qtd_funcionarios) ? 2
                  : Number(e.vendas) >= Number(loja.meta_c/loja.qtd_funcionarios) && Number(e.vendas) < Number(loja.meta_d/loja.qtd_funcionarios) ? 3
                    : 4
          }
          return e;
        });
      });
    },
    dataChanged() {
      this.filtro.fields.periodo = 'Periodo';
    },
    changePeriodo(periodo) {
      switch(periodo) {
        case 'Hoje': {
          this.filtro.fields.dataIni = moment().format('YYYY-MM-DD');
          this.filtro.fields.dataFim = moment().format('YYYY-MM-DD');
          break;
        }
        case 'Ontem': {
          this.filtro.fields.dataIni = moment().subtract(1, 'day').format('YYYY-MM-DD');
          this.filtro.fields.dataFim = moment().subtract(1, 'day').format('YYYY-MM-DD');
          break;
        }
        case 'Semana': {
          this.filtro.fields.dataIni = moment().startOf('week').format('YYYY-MM-DD');
          this.filtro.fields.dataFim = moment().endOf('week').format('YYYY-MM-DD');
          break;
        }
        case 'Mes': {
          this.filtro.fields.dataIni = moment().startOf('month').format('YYYY-MM-DD');
          this.filtro.fields.dataFim = moment().endOf('month').format('YYYY-MM-DD');
          break;
        }
        default: return;
      }
      this.search();
    },
    displayChart(item, tipo) {
      if (item.charts[tipo].datasets) {
        const data = item.charts[tipo].datasets[0].data
        if (data.length === 0 || ['', '0'].includes(data[0])) {
          return false
        }
      }
      return true
    },
    export2image: function (id, name) {
      // Set White Background
      let chart = document.getElementById(id)
      var ctx = chart.getContext("2d");
      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = "#FFF";
      ctx.fillRect(0, 0, chart.width, chart.height);
      ctx.restore();

      // Download image
      let canvas = document.getElementById(id).toDataURL('image/png')
      let link = document.createElement('a')
      link.download = name || 'Grafico'
      link.href = canvas
      link.click()
    },
    parseFilters(filters) {
      let filter = { ...filters };
      const {
        grupos,
        subgrupos,
        fornecedores,
        vendedores,
        classificacoes1,
        classificacoes2,
        classificacoes3,
        gestao,
        centres,
        formaVenda,
        agrupamento
      } = filters;

      // Listas
      const listaGrupos       = this.filtro.listas.grupos;
      const listaSubgrupos    = this.filtro.listas.subgrupos;
      const listaFornecedores = this.filtro.listas.fornecedores;
      const listaVendedores   = this.filtro.listas.vendedores;

      const listaGestoes      = this.filtro.listas.gestao;
      const listaCentres      = this.filtro.listas.centres;
      const listaFormasVenda  = this.filtro.listas.formaVenda;

      // Filtros
      filter.grupos       = grupos.length === 0 ? [] : grupos;
      filter.subgrupos    = subgrupos.length === 0 ? [] : subgrupos;
      filter.fornecedores = fornecedores.length === 0 ? [] : fornecedores;
      filter.vendedores   = vendedores.length === 0 ? [] : vendedores;

      filter.gestao       = gestao.length === 0 ? [] : gestao;
      filter.centres      = centres.length === 0 ? [] : centres;
      filter.formaVenda   = formaVenda.length === 0 ? [] : formaVenda;

      // Join array
      filter.grupos       = (filter.grupos && filter.grupos.map(c => c.value).join(',')) || '0';
      filter.subgrupos    = (filter.subgrupos && filter.subgrupos.map(c => c.value).join(',')) || '0';
      filter.fornecedores = (filter.fornecedores && filter.fornecedores.map(c => c.value).join(',')) || '0';
      filter.vendedores   = (filter.vendedores && filter.vendedores.map(c => c.value).join(',')) || '0';

      filter.gestao       = (filter.gestao && filter.gestao.map(c => c.value).join(',')) || '0';
      filter.centres      = (filter.centres && filter.centres.map(c => c.value).join(',')) || '0';
      filter.formaVenda   = (filter.formaVenda && filter.formaVenda.map(c => c.value).join(',')) || '0';

      filter.classificacoes = '';

      this.filtraClassificacao(classificacoes1, filter);
      this.filtraClassificacao(classificacoes2, filter);
      this.filtraClassificacao(classificacoes3, filter, '}');

      if (filter.centres !== '0' && filter.centres.length === 1) {
        filter.agrupamento = 1
        filter.listaPorVendedor = true
      }
      return filter;
    },
    dynamicColors(count) {
      let result = [ ...this.$store.state.colors ];
      for (let i = 0; i < count; i++) {
        const r = Math.floor(Math.random() * 255);
        const g = Math.floor(Math.random() * 255);
        const b = Math.floor(Math.random() * 255);

        result.push("rgb(" + r + "," + g + "," + b + ",.7)")
      }
      return result;
    },
    filterLojas() {
      const { gestao, centres } = this.filtro.fields;
      const { centresDefault } = this.filtro.listas;
      this.filtro.listas.centres = gestao === 0 ? centresDefault
        : centresDefault.filter(l => l.gestao === gestao || l.value === 0)

      const gestaoCentres = centresDefault.find(c => c.value === centres)
      if (gestaoCentres.gestao !== gestao) {
        this.filtro.fields.centres = 0
      }
    },
    filtrosAvancados() {
      if (this.filtro.filtrosAvancados) {
        this.filtro.fields.grupos = [];
        this.filtro.fields.subgrupos = [];
        this.filtro.fields.fornecedores = [];
        this.filtro.fields.vendedores = [];
      }

      setTimeout(() => {this.filtro.filtrosAvancados = !this.filtro.filtrosAvancados},200);
    },
    clearAll(field) {
      if (this.filtro.fields[field] && this.filtro.fields[field].length > 0) {
        this.filtro.fields[field] = [];
      }
    },
    filtraClassificacao(classificacoes, filtro, addToEnd) {
      if ( classificacoes && (classificacoes.length > 0) ) {
        let classe  = classificacoes.map((item) => { return item.classe; })[0];
        let classif = classificacoes.map((item) => { return item.value;  }).join(',');

        filtro.classificacoes = filtro.classificacoes + (filtro.classificacoes === '' ? '{' : ',');

        if (classe !== '' && classif !== '') {
          filtro.classificacoes = filtro.classificacoes + `{"{${classe}}","{${classif}}"}`
        }
      }

      if (addToEnd) {
        filtro.classificacoes = filtro.classificacoes + (filtro.classificacoes === '' ? '' : addToEnd);
      }

    }
  },
  created() {
    this.search();
  }
}
</script>
